// extracted by mini-css-extract-plugin
module.exports = {"message-container":"ReadMore_message-container__Bk6aw","read-more":"ReadMore_read-more__GUb7K","read-less":"ReadMore_read-less__Bnj4c"};